// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-block{white-space:pre;overflow-wrap:break-word;word-wrap:break-word;overflow-x:auto}.v-toolbar__extension{display:flex;justify-content:center}", ""]);
// Exports
module.exports = exports;
